import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

interface BasicCardProps {
  width: number;
  height: number;
  maxWidth: number;
  color: string;
  children?: React.ReactNode;
  margin?: number;
  marginTop?: number;
}

function CustomCard(props: BasicCardProps) {
  return (
    <Card
      sx={{
        height: props.height,
        maxWidth: props.maxWidth,
        minWidth: props.width,
        borderRadius: 1,
        /*  backgroundColor: props.color, */   // 👈 define a cor do card inteiro
        marginLeft: props.margin ? props.margin : 0,
        marginTop: props.marginTop ? props.marginTop : 0
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 1,
          flex: 1,
          color: '#334155',
          fontWeight: 500,
          '& *': { fontWeight: 500 },
        }}
      >
        {props.children !== undefined && props.children}
      </CardContent>
    </Card>
  );
}

export default CustomCard;
